import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // default is localStorage
import dataReducer from './reducers';

// Redux Persist Configuration
const persistConfig = {
  key: 'root', // key for persistence
  storage, // where to persist (localStorage by default)
};

// Wrap the reducer with persistReducer
const persistedReducer = persistReducer(persistConfig, dataReducer);

// Create the store with the persisted reducer
const store = createStore(
  persistedReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() // Optional: Enable Redux DevTools
);

// Create a persistor to persist the store
const persistor = persistStore(store);

// Export store as default
export default store;
export { persistor }; // Named export for persistor
